import { IUserSignUpPayload } from '../../resource/user/user.types';
import { IApiRequestConfig } from '../api.types';

export const signUpUserApi = (data: IUserSignUpPayload): IApiRequestConfig<unknown> => ({
  apiRouteKey: 'signUpUser',
  uri: 'json',
  action: 'register',
  method: 'post',
  data: data,
  v2: true,
});
